module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-dots-2-75b23aeee713773ef773374ffdd061ba.svg";